<template>
  <div class="radar-page">
    <el-card class="top-card">
      <template #header>
        <div class="card-header">
          <b>📡 爆款雷达</b>
          <div class="actions">
            <el-button size="small" type="primary" plain :loading="collecting" @click="collectNow">
              立即采集
            </el-button>
            <el-button size="small" @click="loadAll">刷新</el-button>
          </div>
        </div>
      </template>
      <div class="radar-desc">
        每天 <b>8:25 / 12:25 / 20:25</b> 自动采集 48 行业的最新爆款（发布 ≤3 天），
        并按你订阅的行业<b>实时推送到顶部🔔消息中心</b>（短信可选）。点「⚡ 一键复刻」把同行爆款变成自己的。
      </div>
      <el-form label-position="left" inline class="settings-form">
        <el-form-item label="雷达推送">
          <el-switch v-model="settings.radar_on" @change="saveSettings" />
        </el-form-item>
        <el-form-item label="短信推送（消耗短信条数）">
          <el-switch v-model="settings.radar_sms_enabled" @change="saveSettings" />
        </el-form-item>
        <el-form-item label="订阅行业（空=全部，选后只推你关注的）">
          <el-select v-model="subIndustries" multiple filterable collapse-tags collapse-tags-tooltip
                     placeholder="全部行业" style="width: 340px" @change="saveSettings">
            <el-option v-for="n in allIndustries" :key="n" :label="n" :value="n" />
          </el-select>
        </el-form-item>
      </el-form>
    </el-card>

    <el-tabs v-model="tab" style="margin-top: 16px">
      <el-tab-pane :label="`爆款列表`" name="videos">
        <el-card>
          <div class="filter-row">
            <el-select v-model="industry" placeholder="全部行业" clearable style="width: 240px" @change="loadVideos">
              <el-option v-for="n in industries" :key="n" :label="n" :value="n" />
            </el-select>
            <span class="count">共 {{ videos.length }} 条（近 2 天）</span>
          </div>
          <el-empty v-if="!videos.length" description="暂无爆款数据，点「立即采集」开始" />
          <div v-else class="video-list">
            <div v-for="v in videos" :key="v.id" class="video-item" @click="openVideo(v.video_url)">
              <div class="v-main">
                <div class="v-title">{{ v.title || '（无标题）' }}</div>
                <div class="v-meta">
                  <el-tag size="small" type="warning">{{ v.industry }}</el-tag>
                  <el-tag v-if="v.publish_text" size="small" type="success" effect="plain">发布 {{ v.publish_text }}</el-tag>
                  <el-tag v-else-if="v.source === 'hot'" size="small" type="info" effect="plain">全网热点</el-tag>
                  <span class="v-author">@{{ v.author || '未知' }}</span>
                  <span class="v-likes">👍 {{ fmtLikes(v.likes) }}</span>
                </div>
              </div>
              <div class="v-side">
                <div class="v-time">{{ v.discover_at }}</div>
                <el-button size="small" type="primary" plain :loading="dlId === v.id" @click.stop="replicaOne(v)">
                  ⚡ 一键复刻
                </el-button>
              </div>
            </div>
          </div>
        </el-card>
      </el-tab-pane>

      <el-tab-pane :label="`消息中心${unread ? '（' + unread + '）' : ''}`" name="messages">
        <el-card>
          <div class="filter-row">
            <span class="count">共 {{ messages.length }} 条推送</span>
            <el-button size="small" @click="markAllRead">全部已读</el-button>
          </div>
          <el-empty v-if="!messages.length" description="暂无推送消息" />
          <div v-else class="msg-list">
            <div v-for="m in messages" :key="m.id" class="msg-item" :class="{ unread: !m.is_read }">
              <div class="msg-title">
                {{ m.title }}
                <el-tag v-if="!m.is_read" size="small" type="danger" style="margin-left: 6px">新</el-tag>
              </div>
              <pre class="msg-content">{{ m.content }}</pre>
              <div class="msg-time">{{ m.created_at }}</div>
            </div>
          </div>
        </el-card>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'Radar',
  data() {
    return {
      tab: 'videos',
      industries: [],
      industry: '',
      allIndustries: [],      // 订阅行业选项（同 48 行业）
      subIndustries: [],      // 已选订阅行业
      videos: [],
      messages: [],
      unread: 0,
      settings: { radar_on: 1, radar_sms_enabled: 0 },
      collecting: false
    }
  },
  created() {
    this.loadAll()
  },
  methods: {
    uid() {
      return Number(localStorage.getItem('user_id') || 0)
    },
    fmtLikes(n) {
      if (n >= 100000000) return (n / 100000000).toFixed(1) + '亿'
      if (n >= 10000) return (n / 10000).toFixed(1) + '万'
      return String(n)
    },
    openVideo(url) {
      if (url) window.open(url, '_blank')
    },
    async loadAll() {
      try {
        const [ind, vid, msg, st] = await Promise.all([
          api.get('/radar/industries'),
          api.get('/radar/videos'),
          this.uid() ? api.get('/radar/messages?user_id=' + this.uid()) : Promise.resolve({ unread: 0, messages: [] }),
          this.uid() ? api.get('/radar/settings?user_id=' + this.uid()) : Promise.resolve({ settings: { radar_on: 1, radar_sms_enabled: 0 } })
        ])
        this.industries = ind.industries || []
        this.allIndustries = this.industries
        this.videos = vid.videos || []
        this.messages = msg.messages || []
        this.unread = msg.unread || 0
        if (st.settings) {
          this.settings = st.settings
          this.subIndustries = (st.settings.radar_industries || '')
            .split(',').map(s => s.trim()).filter(Boolean)
        }
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      }
    },
    async loadVideos() {
      try {
        const r = await api.get('/radar/videos' + (this.industry ? '?industry=' + encodeURIComponent(this.industry) : ''))
        this.videos = r.videos || []
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      }
    },
    async saveSettings() {
      if (!this.uid()) return
      try {
        const body = {
          user_id: this.uid(),
          radar_on: this.settings.radar_on ? 1 : 0,
          radar_sms_enabled: this.settings.radar_sms_enabled ? 1 : 0,
          radar_industries: (this.subIndustries || []).join(',')
        }
        await api.put('/radar/settings', body)
        this.$message.success(this.subIndustries && this.subIndustries.length
          ? `已订阅 ${this.subIndustries.length} 个行业，只推送这些行业的爆款`
          : '已订阅全部行业')
      } catch (e) {
        this.$message.error(e.message || '保存失败')
      }
    },
    async collectNow() {
      this.collecting = true
      try {
        const r = await api.post('/radar/self-collect')
        this.$message.success(r.msg || '采集已启动')
        this.$message.info('采完 48 行业约 10-15 分钟，新爆款会推送到铃铛')
      } catch (e) {
        this.$message.error(e.message || '启动失败（需后台采集 Chrome 在线）')
      } finally {
        this.collecting = false
      }
    },
    async markAllRead() {
      if (!this.uid()) return
      try {
        await api.post('/radar/messages/read?user_id=' + this.uid())
        this.unread = 0
        this.messages = this.messages.map(m => ({ ...m, is_read: 1 }))
      } catch (e) {
        this.$message.error(e.message || '操作失败')
      }
    },
    // ⚡ 一键复刻：下载无水印素材 → 跳复刻页预选（灵感直达）
    async replicaOne(v) {
      if (!Number(localStorage.getItem('user_id'))) {
        this.$message.warning('请先登录后再使用一键复刻')
        return
      }
      this.dlId = v.id
      try {
        const r = await api.post('/radar/replica-prepare', {
          radar_id: v.id,
          account_id: Number(localStorage.getItem('current_account_id') || 0)
        })
        this.$message.success('正在下载无水印素材…完成后自动进入复刻页')
        const assetId = await this.pollDownload(v.id, 60)
        if (!assetId) { this.$message.error('素材下载失败（可能被风控），请稍后重试'); return }
        this.$message.success('素材就绪 ✓ 正在打开爆款复刻…')
        this.$router.push('/replica?source_asset_id=' + assetId)
      } catch (e) {
        this.$message.error((e.response && e.response.data && (e.response.data.detail || e.response.data.msg)) || e.message || '操作失败')
      } finally {
        this.dlId = 0
      }
    },
    async pollDownload(id, tries) {
      for (let i = 0; i < tries; i++) {
        await new Promise(r => setTimeout(r, 2000))
        try {
          const s = await api.get('/radar/replica-status/' + id)
          if (s.status === 'done') return s.asset_id
          if (s.status === 'failed') return 0
        } catch (e) { /* 忽略瞬时错误继续轮询 */ }
      }
      return 0
    }
  }
}
</script>

<style scoped>
.radar-page { padding: 4px; }
.card-header { display: flex; justify-content: space-between; align-items: center; }
.actions { display: flex; gap: 8px; }
.radar-desc { color: #8b949e; font-size: 13px; line-height: 1.7; margin-bottom: 12px; }
.settings-form :deep(.el-form-item) { margin-bottom: 4px; margin-right: 24px; }
.filter-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; }
.count { color: #8b949e; font-size: 13px; }
.video-list { display: flex; flex-direction: column; gap: 10px; }
.video-item {
  display: flex; justify-content: space-between; align-items: center;
  border: 1px solid var(--el-border-color-light, #ebeef5); border-radius: 8px; padding: 10px 14px;
  cursor: pointer; transition: all 0.2s; background: var(--el-bg-color-overlay, #fff);
}
.video-item:hover { border-color: #f59e0b; box-shadow: 0 2px 8px rgba(245, 158, 11, 0.15); }
.v-main { flex: 1; min-width: 0; }
.v-title { font-size: 14px; font-weight: 600; color: var(--el-text-color-primary, #1f2937); line-height: 1.5; }
.v-meta { display: flex; align-items: center; gap: 8px; margin-top: 6px; flex-wrap: wrap; }
.v-author { color: var(--el-text-color-secondary, #606266); font-size: 13px; }
.v-likes { color: #f59e0b; font-weight: 600; font-size: 13px; }
.v-side { display: flex; flex-direction: column; align-items: flex-end; gap: 8px; margin-left: 12px; flex-shrink: 0; }
.v-time { color: var(--el-text-color-placeholder, #909399); font-size: 12px; white-space: nowrap; }
.msg-list { display: flex; flex-direction: column; gap: 10px; }
.msg-item { border: 1px solid var(--el-border-color-light, #ebeef5); border-radius: 8px; padding: 12px 14px; background: var(--el-bg-color-overlay, #fff); }
.msg-item.unread { border-color: #f59e0b; background: rgba(245, 158, 11, 0.08); }
.msg-title { font-weight: 600; color: var(--el-text-color-primary, #1f2937); }
.msg-content {
  white-space: pre-wrap; font-family: inherit; font-size: 13px; color: var(--el-text-color-regular, #4b5563);
  line-height: 1.8; margin: 8px 0 4px; background: transparent;
}
.msg-time { color: var(--el-text-color-placeholder, #909399); font-size: 12px; }
</style>
